"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseSocialContentService = void 0;
var tslib_1 = require("tslib");
var BaseApi_1 = require("../BaseApi");
var context_token_service_1 = require("./context-token.service");
var BaseSocialContentService = /** @class */ (function (_super) {
    tslib_1.__extends(BaseSocialContentService, _super);
    function BaseSocialContentService(groupId, context) {
        var _this = _super.call(this, context) || this;
        _this.groupId = groupId;
        _this.contextTokenRepository = new context_token_service_1.ContextTokenService(context);
        return _this;
    }
    BaseSocialContentService.prototype.getContextToken = function (groupId) {
        if (groupId === void 0) { groupId = this.groupId; }
        return this.contextTokenRepository.getContextToken(groupId);
    };
    return BaseSocialContentService;
}(BaseApi_1.BaseApi));
exports.BaseSocialContentService = BaseSocialContentService;
//# sourceMappingURL=base-social-content.service.js.map